import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { _add_notif } from "../store/actions/notification_actions";
import PusherService from "../services/pusher/pusher-service";
import { set_open_new_notification } from "../store/actions/login_actions";

export const usePusher = () => {
  const { token, email, cpid, cid, channel } = useSelector((state) => state.Login);
  const dispatch = useDispatch();

  useEffect(() => {
    try {
      const interest = [];
      let currentInterest = "public-gmall";
      interest.push(currentInterest);

      if (cid) {
        currentInterest = `${currentInterest}-${cid}`;
        interest.push(currentInterest);
      }

      if (cpid) {
        currentInterest = `${currentInterest}-${cpid}`;
        interest.push(currentInterest);
      }

      if (channel) {
        currentInterest = `${currentInterest}-${channel}`;
        interest.push(currentInterest);
      }

      PusherService.init(interest);
    } catch (e) {
      console.log("Error att pusher", e);
    }

    return () => {
      PusherService.reconnect();
    };
  }, [cid, cpid, channel]);

  useEffect(() => {
    function handleServiceWorkerMessage(event) {
      dispatch(_add_notif(event.data.data));
      dispatch(set_open_new_notification(true));
    }

    navigator.serviceWorker?.addEventListener(
      "message",
      handleServiceWorkerMessage,
    );

    return () => {
      navigator.serviceWorker?.removeEventListener(
        "message",
        handleServiceWorkerMessage,
      );
    };
  }, [dispatch]);

  useEffect(() => {
    if (token && email) {
      PusherService.setUser(
        email,
        token,
        cpid !== "gmall" ? cpid : cid || "gmall",
      );
    }
  }, [email, token, cid, cpid]);
};
